module.exports = __webpack_public_path__ + "img/walmart.4550ec0a.jpeg";